import { Component, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { UtilsProvider } from '../../providers/myria/utils-provider';
import { LoggerProvider, LoggerEvent } from '../../providers/logger/logger';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'rmt-searchbar-input',
  templateUrl: 'rmt-searchbar-input.html'
})
export class RmtSearchBarInputComponent {
  @Input() searchBarId;
  @Input() placeholder = "";
  @Input() searching: boolean = false;
  @Input() autocomplet: boolean = false;
  @Input() formControl: any;
  @Input() isDisabled: boolean = false;
  @Input() inputType: string = 'text';
  @Input() stripPastedSpaces: boolean = false;
  @Output() searchInputEmitter = new EventEmitter<any>();
  @Output() focusEmitter = new EventEmitter<any>();
  @Output() blurEmitter = new EventEmitter<any>();
  @Output() onSelectEmitter = new EventEmitter<any>();
  @Output() onKeyPressEmitter = new EventEmitter<any>();
  @Output() onClearPressEmitter = new EventEmitter<any>();

  @ViewChild('searchdiv') searchdiv;
  inputTimeout;
  lastSearch;

  
  constructor(private translate: TranslateService,
              private utilsProvider: UtilsProvider) {    
  }
  onSearch(ev) {
    this.searchInputEmitter.emit(ev);
  }

  focus(ev) {
    this.focusEmitter.emit(ev);
  }

  blur(ev) {
    this.blurEmitter.emit(ev);
  }

  selectOption(ev) {
    this.onSelectEmitter.emit(ev);
  }

  onKeyPress(ev) {
    this.onKeyPressEmitter.emit(ev);
  }

  onClear(ev) {
    this.onClearPressEmitter.emit(ev);
  }

  onPaste(ev: ClipboardEvent) {
    if (!this.stripPastedSpaces || !ev) {
      return;
    }
    const input = ev.target as HTMLInputElement;
    const clipboard = ev.clipboardData || (window as any).clipboardData;
    const pasted: string = clipboard ? clipboard.getData('text') || '' : '';

    // True only when the paste is a number holding spaces (e.g. '+221 768 123 4567')
    const isSpacedNumber = /^(?=[\s\S]*\d)[\d()+.\-]*\s[\d\s()+.\-]*$/.test(pasted);

    if (!input || input.tagName !== 'INPUT' || !isSpacedNumber) {
      return;
    }
    ev.preventDefault();
    this.insertValue(input, pasted.replace(/\s+/g, ''));
  }

  private insertValue(input: HTMLInputElement, text: string) {
    if (!input) {
      return;
    }
    const current = input.value || '';
    const selection = this.getSelection(input);
    const caret = selection.start + text.length;

    input.value = current.slice(0, selection.start) + text + current.slice(selection.end);
    try {
      input.setSelectionRange(caret, caret);
    } catch (err) {
      LoggerProvider.exception(this, err, LoggerEvent.GeneralException, 'Searchbar input does not support caret positioning after paste');
    }
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }

  private getSelection(input: HTMLInputElement): { start: number, end: number } {
    if (!input) {
      return { start: 0, end: 0 };
    }
    const fallback = (input.value || '').length;
    try {
      return {
        start: typeof input.selectionStart === 'number' ? input.selectionStart : fallback,
        end: typeof input.selectionEnd === 'number' ? input.selectionEnd : fallback
      };
    } catch (err) {
      LoggerProvider.exception(this, err, LoggerEvent.GeneralException, 'Searchbar input exposes no selection range, appending pasted value');
      return { start: fallback, end: fallback };
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/rmt-searchbar-input/rmt-searchbar-input.ts